import { Box, Button } from '@mui/material'
import AllocationRuleTemplatesTable from '@storage/features/carrier-visit-allocation-rules/components/AllocationRuleTemplatesTable'
import AllocationRuleTemplatesTableDialog from '@storage/features/carrier-visit-allocation-rules/components/AllocationRuleTemplatesTableDialog'
import { useStores } from '@storage/hooks/use-stores.hook'
import { useTranslate } from '@tolgee/react'
import { Header, PlusIcon } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'

export const AllocationRuleTemplatesPage = () => {
  const { t } = useTranslate()
  const { allocationRuleTemplatesV2UIStore, carrierVisitAllocationRulesV2UIStore } = useStores()
  const dialogUtilStore = allocationRuleTemplatesV2UIStore.dialogUtilStore
  const title = t('allocationRuleTemplates', 'Allocation Rule Templates')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <>
      <Header
        title={title}
        searchInputLabel={t('searchByName', 'Search by name')}
        breadcrumbs={breadcrumbs}
        displaySearchIcon
        enableSearchField
        onSearchFieldChange={value => allocationRuleTemplatesV2UIStore.setSearchQuery(value)}
        rightRenderOption={
          <Box flex='none'>
            <Button
              color='inherit'
              variant='contained'
              startIcon={<PlusIcon />}
              onClick={() => dialogUtilStore.toggleDialog('Add')}
            >
              {t('addNew', 'Add new')}
            </Button>
          </Box>
        }
      />
      <AllocationRuleTemplatesTable />
      <AllocationRuleTemplatesTableDialog
        destinationUIStore={carrierVisitAllocationRulesV2UIStore}
      />
    </>
  )
}
